import { useTranslation } from '../../i18n/i18n';
import DesktopLayout from '../../layouts/DesktopLayout';
import DesktopFlowFooter from '../../components/DesktopFlowFooter';
import LoadingState from '../../components/LoadingState';

type Props = {
  onCancel: () => void;
  onBack?: () => void;
};

export default function DesktopWaitingPage({ onCancel, onBack }: Props) {
  const { t } = useTranslation();

  const secondaryLabel = onBack ? t('abort.goBack') : t('agentStart.cancel');
  const onSecondary = onBack ?? onCancel;

  return (
    <DesktopLayout>
      <div className="flex flex-1 flex-col w-full">
        <div className="flex flex-1 items-center justify-center w-full">
          <div className="flex flex-col items-center gap-6 text-center max-w-lg w-full">
            <LoadingState
              title={t('waitingForPresentation.title')}
              subtitle={t('waitingForPresentation.hint')}
            />

            <DesktopFlowFooter
              secondaryLabel={secondaryLabel}
              onSecondary={onSecondary}
            />
          </div>
        </div>
      </div>
    </DesktopLayout>
  );
}
